import SETTINGS from '@/src/settings'

export const coeffQuantityDefault = 1

export const getParseImageProduct = (product: any) => {
  const imageOther =
    !!product?.image_pairs && Object.values(product.image_pairs).length
      ? Object.values(product.image_pairs).map((image: any) => ({
          ...image,
          icons: {
            icon_id: image.pair_id,
            iconSmall: image.icons?.['500x500']
              ? image.icons['500x500']
              : image.icons?.['150x150']
                ? image.icons['150x150']
                : null,
          },
        }))
      : []

  const imageMaster =
    product?.main_pair && !!product.main_pair?.pair_id
      ? [
          {
            ...product.main_pair,
            icons: {
              icon_id: product.main_pair.pair_id,
              iconSmall: product.main_pair?.icons?.['500x500']
                ? product.main_pair?.icons['500x500']
                : product.main_pair.icons?.['150x150']
                  ? product.main_pair.icons['150x150']
                  : null,
            },
          },
        ]
      : [
          {
            pair_id: 0,
            detailed: {
              image_path: null,
            },
          },
        ]

  return [...imageMaster, ...imageOther]
}

export const formatProductCommonBasket = (product: any) => ({
  infiniteStock: product.tracking == 'D',
  coeffQuantity: product.qty_step > 0 ? product.qty_step : coeffQuantityDefault,
  seo_name: product.seo_name || product.product_id,
})

export const formatProduct = (product: any) => {
  const product_features: any = product?.product_features
    ? Object.values(product.product_features)
    : null
  const idMarketingPublicPrice = SETTINGS.attributesCodeUse.marketingPublicPriceId || '116'

  return {
    ...product,
    product: product?.product || product.product_code,
    ...formatProductCommonBasket(product),
    pricePublic: undefined,
    image_pairs: getParseImageProduct(product),
    marketingPublicPrice: product_features?.find(
      (feature: any) => String(feature.feature_id) === idMarketingPublicPrice
    )?.value_int,
    planning_shipping_current: {
      date_close: Number(product.planning_shipping_current?.date_close ?? 0),
      date_start_shipping: Number(product.planning_shipping_current?.date_start_shipping ?? 0),
      date_end_shipping: Number(product.planning_shipping_current?.date_end_shipping ?? 0),
    },
    variation_features: product?.variation_features
      ? Object.values(product.variation_features)
      : null,
    product_features,
    variation_features_variants: product?.variation_features_variants
      ? Object.values(product.variation_features_variants).map((variation_features: any) => ({
          ...variation_features,
          variants: Object.values(variation_features.variants).filter((v: any) => !!v?.product_id),
        }))
      : null,
  }
}
